import {Field} from "formik";
import React  from "react";

function Radio(props){
    const {questionName, name ,options, handleChange, isMandatory, ...rest} = props
    return (<>
        {!!questionName &&
            <h2 className="card_medicine_heading">
                {questionName} 
                {isMandatory && <span>*</span>}
            </h2>
        }
        <div className="idp_radio_blk">
            <Field  id={name} name={name} {...rest} > 
                {({field}) => { 
                return options?.map((option, ind) => ( 
                    <div className="idp_radio_group" key={ind}>
                        <input type="radio"
                            onClick={(e)=> handleChange(e)}
                            name={name} id={`${name}-${ind}`} 
                            {...field} 
                            defaultChecked={option.selected}
                            value={option.id}>
                        </input>
                        <label htmlFor={`${name}-${ind}`} name={name}>{option.name || option.short_name}</label>
                    </div>
                ))}}
            </Field> 
        </div>        
    </>)
}
export default Radio